module.exports = __webpack_public_path__ + "img/advantage3.8911db17.svg";